/** @jsx jsx */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { jsx, css } from '@emotion/core'
import { withRouter } from 'react-router'
import { has } from 'lodash'
import ButtonBar from '../../components/ButtonBar'
import AdminMainLayout from './AdminMainLayout'
import CommonTable from '../../components/CommonTable'
import Timestamp from '../../components/Timestamp'
import DefaultButton from '../../components/DefaultButton'
import TableHeader from '../../components/TableHeader'
import TableFooter from '../../components/TableFooter'
import TableFilter from '../../components/TableFilter'
import { Button } from 'react-bootstrap'
import { adminCertificateConfigList } from '../actions/admin_certificate_config'
import Card from '../../components/layout/Card'

class AdminCertificateConfigs extends Component {
 
    componentDidMount() {
        const { dispatch } = this.props
        dispatch(adminCertificateConfigList.fetchListIfNeeded())
    }

    componentDidUpdate() {
        const { dispatch } = this.props
        dispatch(adminCertificateConfigList.fetchListIfNeeded())
    }

    onEdit = (evt, item) => {
        const { history } = this.props
        history.push('/admin/certificate_config/' + item.id)
    }

    onAdd = () => {
        const { history } = this.props
        history.push('/admin/certificate_config/')
    }

    filterCertificateConfigs = (filter_values) => {
        const { dispatch } = this.props
        dispatch(adminCertificateConfigList.updateListFilter(filter_values))
    }

    sortOnHeader = (key) => {
        const { dispatch, course_filter } = this.props
        if (key !== 'action' && key !== 'admin_email') {
            let sort_by = key
            if (has(course_filter, 'order_by') && course_filter['order_by'] === key) {
                sort_by = '-' + key
            }
            dispatch(adminCertificateConfigList.updateListFilter({'order_by': sort_by}))
        }
    }
    
    getCertificateConfigsCellValue = (header_key, item, index) => {
        switch( header_key ) {
            case 'created_at':
            return (
                <Timestamp value={item.created_at} format='datetime' />
            )
            case 'enabled':
                return (
                    <>
                      { item.enabled && "Yes" }
                      { !item.enabled && "No" }
                    </>
                )
            case 'action':
                return (
                    <ButtonBar>
                      <Button onClick={(evt) => this.onEdit(evt, item)}>
                        Edit
                      </Button>
                    </ButtonBar>
                )
            default:
                return undefined
        }
    }

    render() {
        const {
            course_headers,
            certificate_configs,
            is_loading,
            course_filter,
        } = this.props
        
        return (
            <AdminMainLayout title="Certificate Config List">
              <Card>
                <TableHeader>
                  <div css={ css`width:100%;`}>
                    <TableFilter
                        updateOnChange={ this.filterCertificateConfigs }
                        form="ADMIN_CERTIFICATE_CONFI_FILTER_FORM"
                    />
                  </div>
                  <div css={ header }>
                    <DefaultButton
                        label="Add Certificate Config"
                        type="button"
                        light={ true }
                        onClickButton={ this.onAdd }
                    />
                  </div>
                </TableHeader>
                <CommonTable
                    is_loading={ is_loading }
                    empty_message="There are no certificate configs."
                    headers={ course_headers }
                    items={ certificate_configs }
                    getCellValue={ this.getCertificateConfigsCellValue }
                    sortOnHeader={ this.sortOnHeader }
                    item_list={adminCertificateConfigList}
                />
                <TableFooter>
                </TableFooter>
              </Card>
            </AdminMainLayout>
        )
    }
}

function mapStateToProps(state, props) {
    const certificate_configs = adminCertificateConfigList.getVisibleObjects() || []
    return {
        certificate_configs,
        course_filter: adminCertificateConfigList.getFilter(),
        course_headers: {
            created_at: { name: 'Date Created', column_size: 1 },
            certificate_name: { name: 'Name', column_size: 1 },
            enabled: { name: "Enabled" },
            action: { name: 'Action', column_size: 1 }
        },
        is_loading: adminCertificateConfigList.isLoading()
    }
}
export default withRouter(connect(mapStateToProps)(AdminCertificateConfigs))

const header = css`
display: flex;
justify-content: flex-end;
width: 100%;
`
